const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.startOutputBuffer();
                this.echo(`  `);
                this.echo(this.include(context, this.source, this.loadTemplate(`9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8`, `9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8`, 2, 47), undefined, true, false, 2));
                context.proxy[`_hype_group`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
`);
                this.echo(this.include(context, this.source, this.loadTemplate(`9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8`, `9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8`, 39, 48), new Map([[`class`, (((context.has(`container_class`))) ? (this.env.getFilter('default').traceableCallable(40, this.source)(...[(context.has(`container_class`) ? context.get(`container_class`) : null), `o-container--pad`])) : (`o-container--pad`))], [`_hype_group`, (context.has(`_hype_group`) ? context.get(`_hype_group`) : null)]]), false, false, 39));
            }

            getTemplateName() {
                return `9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8`, ``);
            }
        }],
        [47, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/hype-group/hype-group.twig`, `9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8`, 2);

                this.blocks = new Map([
                    ['intro', [this, 'block_intro']],
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/hype-group/hype-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_intro(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`content`, `Let’s get hyped for this content!`], [`level`, 0], [`tag_name`, `h2`]]), false, false, 4));
                this.echo(`    `);
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      <img src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(11, this.source)(...[this.env, (context.has(`example_object_img_src`) ? context.get(`example_object_img_src`) : null), `html`, null, true]));
                this.echo(`"
        alt="Example object image"
        width="`);
                this.echo(this.env.getFilter('escape').traceableCallable(13, this.source)(...[this.env, (context.has(`example_object_img_size`) ? context.get(`example_object_img_size`) : null), `html`, null, true]));
                this.echo(`"
        height="`);
                this.echo(this.env.getFilter('escape').traceableCallable(14, this.source)(...[this.env, (context.has(`example_object_img_size`) ? context.get(`example_object_img_size`) : null), `html`, null, true]));
                this.echo(`">
    `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce nulla nulla, vestibulum vel pharetra ut, suscipit sit amet orci. Aliquam interdum tristique tincidunt.</p>
      `);
                if (((context.has(`example_paragraphs`) ? context.get(`example_paragraphs`) : null) > 2)) {
                    this.echo(`        <p>Nunc pellentesque eu purus vel aliquet. Vestibulum sed nulla tellus. Sed sed ante varius, facilisis dui in, lacinia dui. Sed convallis aliquam dolor, sit amet pretium nibh dignissim quis.</p>
      `);
                }
                this.echo(`      `);
                if (((context.has(`example_paragraphs`) ? context.get(`example_paragraphs`) : null) > 3)) {
                    this.echo(`        <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Mauris turpis justo, condimentum pharetra urna aliquet, vehicula mattis neque.</p>
      `);
                }
                this.echo(`      `);
                if (((context.has(`example_paragraphs`) ? context.get(`example_paragraphs`) : null) > 1)) {
                    this.echo(`        `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/media-link/media-link.twig`, new Map([[`href`, `https://cloudfour.com/thinks/performance-is-an-issue-of-equity/`], [`label`, `Cloud Four partner Megan Notarte explains why performance is an issue of equity`], [`action_class`, `u-text-small`], [`avatar`, `/media/megan.png`], [`avatar_width`, 88], [`avatar_height`, 88], [`icon`, `arrow-right`]]), false, false, 25));
                    this.echo(`      `);
                }
                this.echo(`    `);
            }

            getTemplateName() {
                return `9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8`, ``);
            }
        }],
        [48, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8`, 39);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.env.getFilter('escape').traceableCallable(44, this.source)(...[this.env, (context.has(`_hype_group`) ? context.get(`_hype_group`) : null), `html`, null, true]));
                this.echo(`
  `);
            }

            getTemplateName() {
                return `9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8');

let template = env.loadTemplate('9636b239ff935ede144b6f1951e382acc9b428d5d626eef88b9c9a48284084b8');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/hype-group/demo/single.twig", args: context }
     );
     return rendered;;
};